import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { iso: String }

  connect() {
    const d = new Date(this.isoValue)
    this.element.title = d.toLocaleString(undefined, {
      year: "numeric", month: "short", day: "numeric",
      hour: "numeric", minute: "2-digit", timeZoneName: "short"
    })
  }
}
